import React, { Fragment, useEffect, useState } from 'react'

// icons
import {
    faBuilding,
    faCubes,
    faFileExcel,
    faPlus,
    faTrash,
    faList,
    faCog,
    faBarcode,
} from '@fortawesome/free-solid-svg-icons'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import ItemStockSucursal from './ItemStockSucursal'
import Header from '../Header/Header'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

// route
import { withRouter } from 'react-router-dom'

// services
import { getAllStockSucursal } from '../../Services/stockSucursalService'
import { getAllSucursales } from '../../Services/sucursalService'
import { exportStockWithColumns } from '../../Services/reporteService'

// alert swal
import Swal from 'sweetalert2'
import { getAllListasPrecios } from '../../Services/listaPrecioService'

const StockSucursal = ({ history, location }) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]

    const [isLoad, setIsLoad] = useState(true)
    const [stockSucursal, setStocksSucursales] = useState([])
    const [sucursales, setSucursales] = useState([])
    const [sucursal, setSucursal] = useState(token.sucursal)
    const [listaPrecios, setListaPrecios] = useState([]);
    const [listaPrecio, setListaPrecio] = useState({
        id: null,
        nombre: 'SIN LISTA'
    });

    //Pagination
    const [page, setPage] = useState(0)
    const [totalRegister, setTotalRegister] = useState(0)
    const [totalPage, setTotalPage] = useState(0)
    const [query, setQuery] = useState('')
    const [searchCriteria, setSearchCriteria] = useState('nombre') // 'nombre', 'codigo', 'codigoBarra'

    // Modal Exportar
    const [selectedColumns, setSelectedColumns] = useState({
        codigo: true,
        articulo: true,
        costo: true,
        precioFinal: true,
        precioCalculado: true,
        precioFinalSucursal: true,
        pesable: true,
        pesoPromedio: true,
        cantidad: true,
        unidadMedida: true,
        fechaModificacion: true,
        familia: true,
        marca: true,
        sucursalId: true,
        codigoBarra1: false,
        codigoBarra2: false,
    })

    useEffect(() => {
        if (rol !== 'ROLE_ADMIN') history.goBack()
        getAllSucursales(true, 0, '', 1000)
            .then((res) => {
                setSucursales(res.data.content)
            })
            .catch((err) => console.log('error get sucursal'))
        getAllStockSucursal(true, page, sucursal.id, listaPrecio.id)
            .then((res) => {
                setStocksSucursales(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
            })
            .catch((err) => console.log('error get stock sucursal'));
        getAllListasPrecios(true, 0, '', 1000)
            .then((res) => {
                setListaPrecios(
                    [{
                        id: null,
                        nombre: 'SIN LISTA'
                    },
                    ...res.data.content
                    ]
                );
            })
            .catch((err) => console.log('error get listas precios'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoad, sucursal, listaPrecio])

    const goToDeleted = () => {
        history.push('/delete-stock-sucursal', { sucursal })
    }

    const goToGenerarEtiquetas = () => {
        history.push('/generar-etiquetas')
    }

    const nextPage = () => {
        if (totalPage === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        if (page === totalPage - 1) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllStockSucursal(true, page + 1, sucursal.id, listaPrecio.id, '', '', query, 50)
            .then((res) => {
                setPage(page + 1)
                setStocksSucursales(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
            })
            .catch((err) => console.log('error'))
    }

    const previousPage = () => {
        if (page === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllStockSucursal(true, page - 1, sucursal.id, listaPrecio.id, '', '', query, 50)
            .then((res) => {
                setPage(page - 1)
                setStocksSucursales(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
            })
            .catch((err) => console.log('error'))
    }

    const handleBuscador = (e) => {
        if (e.key === 'Enter') {
            const searchValue = e.target.value
            setQuery(searchValue)

            // Preparar parámetros según el criterio seleccionado
            let codigoBarra = ''
            let codigo = ''
            let nombre = ''

            if (searchCriteria === 'codigoBarra') {
                codigoBarra = searchValue
            } else if (searchCriteria === 'codigo') {
                codigo = searchValue
            } else {
                nombre = searchValue
            }

            getAllStockSucursal(
                true,
                0,
                sucursal.id,
                listaPrecio.id,
                codigoBarra,
                codigo,
                nombre,
                50
            )
                .then((res) => {
                    setPage(0)
                    setStocksSucursales(res.data.content)
                    setTotalRegister(res.data.totalElements)
                    setTotalPage(res.data.totalPages)
                    setIsLoad(false)
                })
                .catch((err) => console.log('error'))
        }
    }

    const getCriteriaLabel = () => {
        switch (searchCriteria) {
            case 'codigo':
                return 'Código'
            case 'codigoBarra':
                return 'Código de Barra'
            default:
                return 'Nombre'
        }
    }


    const handleToggleColumn = (columnKey) => {
        setSelectedColumns((prev) => ({
            ...prev,
            [columnKey]: !prev[columnKey],
        }))
    }

    const getSelectedColumnsArray = () => {
        return Object.keys(selectedColumns).filter(
            (key) => selectedColumns[key]
        )
    }

    const handleExportarExcel = async () => {
        try {
            // Obtener todos los datos del stock
            const stockData = await getAllStockSucursal(
                true,
                0,
                sucursal.id,
                listaPrecio.id,
                '',
                '',
                '',
                20000
            )

            const selectedColumnsArray = getSelectedColumnsArray()
            const response = await exportStockWithColumns(
                stockData.data.content,
                selectedColumnsArray,
                'excel'
            )

            // Procesar la respuesta base64 y descargar
            const byteCharacters = atob(response.data)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })

            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = 'stock.xlsx'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al generar la exportación.',
                showConfirmButton: true,
            })
        }
    }

    const handleExportarPdf = async () => {
        try {
            const selectedColumnsArray = getSelectedColumnsArray()

            // Cerrar el modal de Bootstrap
            const modalElement = document.getElementById('modalExportarStock')
            if (modalElement) {
                modalElement.classList.remove('show')
                modalElement.style.display = 'none'
                document.body.classList.remove('modal-open')
                const modalBackdrop = document.querySelector('.modal-backdrop')
                if (modalBackdrop) {
                    modalBackdrop.remove()
                }
            }

            // Mostrar indicador de carga
            Swal.fire({
                title: 'Generando PDF...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            // Obtener todos los datos del stock
            const stockData = await getAllStockSucursal(
                true,
                0,
                sucursal.id,
                listaPrecio.id,
                '',
                '',
                '',
                20000
            )

            const response = await exportStockWithColumns(
                stockData.data.content,
                selectedColumnsArray,
                'pdf'
            )

            // Cerrar el indicador de carga
            Swal.close()

            // Procesar el PDF y abrirlo en una nueva ventana
            const contenido = encodeURI(response.data)
            let pdfWindow = window.open('')
            pdfWindow.document.write(
                `<iframe width='100%' height='100%' margin='0px' padding='0px' src='data:application/pdf;base64,${contenido}'>
                </iframe>`
            )
        } catch (error) {
            Swal.close()
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Hubo un problema al generar el PDF.',
                showConfirmButton: true,
            })
        }
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faCubes} title={'Stock Sucursal'} />
                </div>

                <div className="d-flex bg-gris p-3 align-items-center justify-content-between">
                    <div className="d-flex">
                        <button
                            className="btn btn-outline-success btn-lg mr-2"
                            onClick={() => {
                                history.push('/add-stock-sucursal')
                            }}
                        >
                            <FontAwesomeIcon icon={faPlus} /> Añadir Stock
                        </button>
                        <button
                            className="btn btn-outline-warning btn-lg mr-2"
                            onClick={() => {
                                history.push('/add-stock-sucursal-importar')
                            }}
                        >
                            <FontAwesomeIcon icon={faList} /> Importar
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-danger btn-lg mr-2"
                            data-toggle="modal"
                            data-target="#modalExportarStock"
                        >
                            <FontAwesomeIcon icon={faFileExcel} /> Exportar
                        </button>
                        <button
                            className="btn btn-outline-primary btn-lg mr-2"
                            onClick={goToDeleted}
                        >
                            <FontAwesomeIcon icon={faTrash} /> Eliminados
                        </button>
                        <button
                            className="btn btn-outline-info btn-lg mr-2"
                            onClick={goToGenerarEtiquetas}
                        >
                            <FontAwesomeIcon icon={faBarcode} /> Etiquetas
                        </button>
                        {rol === 'ROLE_ADMIN' ? (
                            <button
                                className="btn btn-outline-warning btn-lg mr-2"
                                onClick={() => {
                                    history.push('/stock-informes')
                                }}
                            >
                                <FontAwesomeIcon icon={faList} /> Informes
                            </button>
                        ) : null}
                    </div>
                    <div className="p-2 flex-grow-1 bd-highlight">
                        <div className="input-group input-group-lg">
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faSearch} />
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control form-lg"
                                id="inputNombre"
                                name="precio"
                                placeholder={`Buscar por ${getCriteriaLabel().toLowerCase()}...`}
                                onKeyPress={(e) => {
                                    handleBuscador(e)
                                }}
                            />
                            <div className="input-group-append">
                                <div className="input-group-prepend">
                                    <button
                                        className="btn btn-outline-secondary dropdown-toggle"
                                        type="button"
                                        id="dropdownSearchCriteria"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        title={`Criterio actual: ${getCriteriaLabel()}`}
                                    >
                                        <FontAwesomeIcon color='black' icon={faCog} />
                                    </button>
                                    <div
                                        className="dropdown-menu dropdown-menu-right"
                                        aria-labelledby="dropdownSearchCriteria"
                                    >
                                        <button
                                            className={`dropdown-item ${searchCriteria === 'nombre' ? 'active' : ''}`}
                                            onClick={() => setSearchCriteria('nombre')}
                                        >
                                            Nombre
                                        </button>
                                        <button
                                            className={`dropdown-item ${searchCriteria === 'codigo' ? 'active' : ''}`}
                                            onClick={() => setSearchCriteria('codigo')}
                                        >
                                            Código
                                        </button>
                                        <button
                                            className={`dropdown-item ${searchCriteria === 'codigoBarra' ? 'active' : ''}`}
                                            onClick={() => setSearchCriteria('codigoBarra')}
                                        >
                                            Código de Barra
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {rol === 'ROLE_ADMIN' ? (
                        <div className="p-2 bd-highlight">
                            <div className="dropdown">
                                <button
                                    className="btn btn-outline-info btn-lg dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <FontAwesomeIcon icon={faBuilding} />{' '}
                                    {`${sucursal.nombre}`}
                                </button>
                                <div
                                    className="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    {sucursales.map((sucursal) => {
                                        return (
                                            <button
                                                key={sucursal.id}
                                                className="dropdown-item"
                                                onClick={() =>
                                                    setSucursal(sucursal)
                                                }
                                            >
                                                {sucursal.nombre}
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {rol === 'ROLE_ADMIN' ? (
                        <div className="p-2 bd-highlight">
                            <div className="dropdown">
                                <button
                                    className="btn btn-outline-danger btn-lg dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <FontAwesomeIcon icon={faList} />{' '}
                                    {`${listaPrecio.nombre}`}
                                </button>
                                <div
                                    className="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    {listaPrecios.map((lista) => {
                                        return (
                                            <button
                                                key={lista.id}
                                                className="dropdown-item"
                                                onClick={() =>
                                                    setListaPrecio(lista)
                                                }
                                            >
                                                {lista.nombre}
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>

                <div className="bg-gris p-3">
                    <div className="d-flex flex-row bd-highlight">
                        <div className="p-2 bd-highlight">
                            <button
                                className="btn btn-outline-info"
                                onClick={() => previousPage()}
                                aria-label="Previous"
                            >
                                <span aria-hidden="true">&laquo; Anterior</span>
                            </button>
                        </div>
                        <div className="p-2 bd-highlight mt-1">
                            Registros: {totalRegister} | Pagina actual:{' '}
                            {page + 1} | Total páginas : {totalPage}
                        </div>
                        <div className="p-2 bd-highlight">
                            <button
                                className="btn btn-outline-info"
                                onClick={() => nextPage()}
                                aria-label="Next"
                            >
                                <span aria-hidden="true">
                                    Siguiente &raquo;
                                </span>
                            </button>
                        </div>
                    </div>

                    <table className="table table-striped mt-3 text-center">
                        <thead>
                            <tr>
                                <th scope="col">Codigo</th>
                                <th scope="col">Articulo</th>
                                <th scope="col">Costo</th>
                                <th scope="col">Precio Final</th>
                                <th scope="col">Precio Calculado</th>
                                <th scope="col">Precio Final Sucursal</th>
                                <th scope="col">Pesable</th>
                                <th scope="col">Peso Promedio</th>
                                <th scope="col">Cantidad</th>
                                <th scope="col">Unidad Medida</th>
                                <th scope="col">Fecha Modificación</th>
                                <th scope="col">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {stockSucursal.map((articulo) => (
                                <ItemStockSucursal
                                    key={parseInt(articulo.articulo.id)}
                                    articulo={articulo}
                                    sucursal={sucursal}
                                    setIsLoad={setIsLoad}
                                />
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal Exportar */}
            <div
                className="modal fade"
                id="modalExportarStock"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalExportarStockTitle"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5
                                className="modal-title"
                                id="modalExportarStockTitle"
                            >
                                Configurar Exportación
                            </h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="mb-3">
                                Seleccione las columnas que desea incluir en la
                                exportación:
                            </p>
                            <div className="form-group">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkCodigo"
                                        checked={selectedColumns.codigo}
                                        onChange={() =>
                                            handleToggleColumn('codigo')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkCodigo"
                                    >
                                        Código
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkArticulo"
                                        checked={selectedColumns.articulo}
                                        onChange={() =>
                                            handleToggleColumn('articulo')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkArticulo"
                                    >
                                        Artículo
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkCosto"
                                        checked={selectedColumns.costo}
                                        onChange={() =>
                                            handleToggleColumn('costo')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkCosto"
                                    >
                                        Costo
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkPrecioFinal"
                                        checked={selectedColumns.precioFinal}
                                        onChange={() =>
                                            handleToggleColumn('precioFinal')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkPrecioFinal"
                                    >
                                        Precio Final
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkPrecioCalculado"
                                        checked={
                                            selectedColumns.precioCalculado
                                        }
                                        onChange={() =>
                                            handleToggleColumn('precioCalculado')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkPrecioCalculado"
                                    >
                                        Precio Calculado
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkPrecioFinalSucursal"
                                        checked={
                                            selectedColumns.precioFinalSucursal
                                        }
                                        onChange={() =>
                                            handleToggleColumn(
                                                'precioFinalSucursal'
                                            )
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkPrecioFinalSucursal"
                                    >
                                        Precio Final Sucursal
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkPesable"
                                        checked={selectedColumns.pesable}
                                        onChange={() =>
                                            handleToggleColumn('pesable')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkPesable"
                                    >
                                        Pesable
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkPesoPromedio"
                                        checked={selectedColumns.pesoPromedio}
                                        onChange={() =>
                                            handleToggleColumn('pesoPromedio')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkPesoPromedio"
                                    >
                                        Peso Promedio
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkCantidad"
                                        checked={selectedColumns.cantidad}
                                        onChange={() =>
                                            handleToggleColumn('cantidad')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkCantidad"
                                    >
                                        Cantidad
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkUnidadMedida"
                                        checked={selectedColumns.unidadMedida}
                                        onChange={() =>
                                            handleToggleColumn('unidadMedida')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkUnidadMedida"
                                    >
                                        Unidad Medida
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkFechaModificacion"
                                        checked={
                                            selectedColumns.fechaModificacion
                                        }
                                        onChange={() =>
                                            handleToggleColumn(
                                                'fechaModificacion'
                                            )
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkFechaModificacion"
                                    >
                                        Fecha Modificación
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkFamilia"
                                        checked={selectedColumns.familia}
                                        onChange={() =>
                                            handleToggleColumn('familia')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkFamilia"
                                    >
                                        Familia
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkMarca"
                                        checked={selectedColumns.marca}
                                        onChange={() =>
                                            handleToggleColumn('marca')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkMarca"
                                    >
                                        Marca
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkSucursalId"
                                        checked={selectedColumns.sucursalId}
                                        onChange={() =>
                                            handleToggleColumn('sucursalId')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkSucursalId"
                                    >
                                        Sucursal Id
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkCodigoBarra1"
                                        checked={selectedColumns.codigoBarra1}
                                        onChange={() =>
                                            handleToggleColumn('codigoBarra1')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkCodigoBarra1"
                                    >
                                        Codigo de Barra 1
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkCodigoBarra2"
                                        checked={selectedColumns.codigoBarra2}
                                        onChange={() =>
                                            handleToggleColumn('codigoBarra2')
                                        }
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="checkCodigoBarra2"
                                    >
                                        Codigo de Barra 2
                                    </label>
                                </div>
                            </div>
                            <div className="alert alert-warning mt-3 mb-0" role="alert">
                                <strong>Nota:</strong> Para el formato PDF, se recomienda seleccionar máximo 6 columnas, ya que más columnas pueden no caber en la pantalla debido a limitaciones del formato.
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Cancelar
                            </button>
                            <button
                                type="button"
                                className="btn btn-success mr-2"
                                onClick={handleExportarExcel}
                            >
                                <FontAwesomeIcon icon={faFileExcel} /> Excel
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={handleExportarPdf}
                            >
                                <FontAwesomeIcon icon={faFileExcel} /> PDF
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(StockSucursal)
